/**
 * IDE DashboardLayout
 */
import _ from 'underscore';
import Handlebars from 'handlebars';
import Marionette from 'backbone.marionette';
import template from '@/../templates/dashboard/layout.hbs';

    var DashboardLayout = Marionette.View.extend({
        className: 'dashboard',
        template: Handlebars.compile(template),
        ui: {
            group_container: '.group-container'
        },
        templateContext: function() {
            return {
                uuid: this.model.get('id') || 'unknown',
                name: this.model.get('name') || 'unknown'
            };
        },
        onAttach: function() {
            if (this.options.new_left_nav) {
                this.ui.group_container.addClass('new-left-nav');
            }
            // For each group, create DOM element, region, and show view
            _(this.options.groups).each(function(group, index) {
                this.ui.group_container.append('<div class="row group-' + index + '"></div>');
                this.addRegion('group_' + index, '.group-' + index)
                    .show(group);
            }, this);
        }
    });

    export default DashboardLayout;

